import { Box } from "@mui/material";
import { HttpRequestInterceptor } from "interceptor/http-request.interceptor";
import { HttpResponseInterceptor } from "interceptor/http-response.interceptor";
import { useSnackbar } from "notistack";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./App.css";
import AppRouting from "./AppRouting";

function App() {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    HttpRequestInterceptor();
    HttpResponseInterceptor(navigate, enqueueSnackbar);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Box color="background.main">
      <AppRouting />
    </Box>
  );
}

export default App;
